<script setup lang="ts">
    


</script>
<template>
    <div class="tw-flex tw-flex-wrap xl:tw-flex-nowrap tw-gap-2 xl:tw-gap-12 xl:tw-text-2xl tw-leading-none tw-tracking-tight tw-item-start tw-w-full">
        <a :href="menu.route_name"  v-for="menu in navbar_menu">{{ $t(`${menu.name}`) }}</a>
    </div>
</template>